module.exports = __webpack_public_path__ + "media/images/flags/FK-1fc6dc4a50e2a1bd1e79bfbdc08bc57b.svg";